import styled from 'styled-components';

import { SecondaryButton } from 'styled/components/Button';

interface iconButtonProps {
  noText?: boolean;
  width?: number;
}

export default styled(SecondaryButton)<iconButtonProps>`
  padding: 4px 2px;
  width: ${(props) => (props.width ? props.width + 'px' : props.noText ? '62px' : '87px')};
  text-align: ${(props) => (props.noText ? 'center' : 'left')};
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 1;

  &.active,
  &:focus {
    background-color: ${(props) => props.theme.colors.secondary} !important;
  }

  &.disabled {
    cursor: not-allowed;
    background-color: ${(props) => props.theme.colors.grey};
  }

  .icon {
    width: 26px;
    height: 26px;
    margin: ${(props) => (props.noText ? '0px auto 0px auto' : '0px 3px 0px 0px')};
  }
`;
